import { withViewer } from 'libs/wrapper/withViewer';
import { useEffect, useRef, useState } from 'react';

import { useViewer } from '@vimeo/viewer';

import styles from './RLEPrivateOverlay.module.scss';
import { VimeoLogoIcon } from './VimeoLogoIcon';
import { PRIVATE_LOGIN_STATE } from '../constants/private_login';
import { getPrivateLoginText } from '../utils/getPrivateLoginText';
import { createLoginHandler } from '../utils/privateLoginHandler';

const VIMEO_BLUE = '#00adef';

export const RLEPrivateOverlay = withViewer(
  ({ handleLogin, sso, color, isOwner, playlistId }) => {
    const viewer = useViewer();
    const loggedInNotOwner = viewer?.user && !isOwner;
    const [loginState, setLoginState] = useState(
      loggedInNotOwner
        ? PRIVATE_LOGIN_STATE.LOGGED_IN_NOT_OWNER
        : PRIVATE_LOGIN_STATE.NOT_LOGGED_IN,
    );

    const loginHandlerRef = useRef(null);

    const onClick = () => {
      loginState === PRIVATE_LOGIN_STATE.ALL_ACCESS_ATTEMPTS_FAILED
        ? window.open(`/event/${playlistId}`, '_blank')
        : loginHandlerRef.current.onLoginRequested();
    };

    useEffect(() => {
      loginHandlerRef.current = createLoginHandler({
        handleLogin,
        sso,
        setLoginState,
        loggedInNotOwner,
      });
    }, [handleLogin, sso, setLoginState, loggedInNotOwner]);

    const privateLoginText = getPrivateLoginText(loginState, sso);

    return (
      <div className={styles.privateErrorState}>
        <h1 className={styles.privateErrorStateMessage}>{privateLoginText.title}</h1>
        <p className={styles.privateErrorStateSubtitle}>{privateLoginText.subtitle}</p>
        {!viewer?.user && (
          <button
            style={{
              backgroundColor: color ? `#${color}` : VIMEO_BLUE,
              borderColor: color ? `#${color}` : VIMEO_BLUE,
            }}
            onClick={onClick}
            className={styles.privateErrorLoginButton}
          >
            {privateLoginText.buttonText}
          </button>
        )}
        <div className={styles.logo}>
          <VimeoLogoIcon />
        </div>
      </div>
    );
  },
  { hideSpinner: true },
);
